class QuotationResultErrorComponent {
    /** @ngInject */
    constructor(DeviceChecker, ContractDraft, ErrorCatcher) {
        this.isMobile = DeviceChecker.isMobile
        this.contractDraftService = ContractDraft
        this.errorCatcher = ErrorCatcher
    }

    retryGetQuotation() {
        this.onDispatch({
            $event: (dispatch, getState) => {
                dispatch({ type: 'GET_QUOTATION' })
                this.contractDraftService.getQuotation({ return: 'offer,timetable' }, getState().quotation.consumptionView.consumptionForm).$promise
                .then((quotationResult) => {
                    dispatch({ type: 'GET_QUOTATION_DONE', quotationResult })
                })
                .catch((error) => {
                    this.errorCatcher.catchError(error)
                    dispatch({ type: 'GET_QUOTATION_ERROR', error })
                })
            },
        })
    }
}

export default {
    template: require('./quotationResultError.jade')(),
    controller: QuotationResultErrorComponent,
    bindings: {
        store: '<',
        onDispatch: '&',
    },
}



// WEBPACK FOOTER //
// ./src/states/quotation/component/quotationResultError.js